import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { deactivateOdpAccess } from "api/individual-user-management";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
// import { ReactComponent as LinkIcon } from "assets/icons/link-rounded-red.svg";
import { transactionLimitModalHeaderCss } from "features/individuals/individual-details/styles";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { IDeactivateOdpAccessModalProps } from "./types";

export const DeactivateOdpAccess = (props: IDeactivateOdpAccessModalProps) => {
  const {
    isOpen,
    setIsOpen,
    handleToggleDeactivateOdpAccessModal,
    employeeId,
  } = props;

  const [isDeactivating, setIsDeactivating] = useState(false);

  const handleDeactivateOdpAccess = async () => {
    try {
      setIsDeactivating(true);
      const { error, message } = await deactivateOdpAccess({
        employeeId,
      });
      if (error) {
        customErrorToast({
          message,
        });
      } else {
        setIsDeactivating(false);
        customSuccessToast({ message });
      }
      handleToggleDeactivateOdpAccessModal();
    } catch (error) {
      console.error("Error: ", error);
      setIsDeactivating(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        // height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="rejection"
          // HeaderIcon={<LinkIcon />}
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Deactivate ODP Access
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
          <Box className="bg-[#FEF5E7] border border-[#FFEFD8] rounded-2xl p-3 flex items-center gap-[8px]">
            <InfoOutlineIcon className="flex-shrink-0" />
            <Paragraph3
              lineHeight="20px"
              textColor=" #1A202C"
            >
              This individual will not be able to access On-Demand Pay unless
              reactivated.
            </Paragraph3>
          </Box>
        </Box>
      </Box>
      <Box
        css={{
          //   height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleDeactivateOdpAccessModal}
          disabled={isDeactivating}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handleDeactivateOdpAccess}
          disabled={isDeactivating}
          loading={isDeactivating}
          loadingText="Deactivating..."
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};
